import { useFormikContext } from "formik";
import { useEffect } from "react";
import { OrDropdown } from "../shared_modules/ui/components/atoms/or-dropdown/or-dropdown";
import { useCities } from "./useCities";

export function CitySelect(props) {
  const { setFieldValue } = useFormikContext();
  const [cities, loadCities] = useCities();

  useEffect(() => {
    if (cities && props.value && !cities.find((city) => city.id === props.value)) {
      setFieldValue("city", "");
    }
  }, [cities, props.value, setFieldValue]);

  useEffect(() => {
    if (props.provinceSelected) {
      loadCities(props.provinceSelected);
    }
  }, [loadCities, props.provinceSelected]);

  let view = "";

  if (cities) {
    view = (
      <div className="or-auth-form__group">
        <OrDropdown
          disableClearable={true}
          errorText={props.touched.city ? props.errors.city : ""}
          getOptionLabel={(option) => {
            let id = option;
            if (option.id) {
              id = option.id;
            }

            const selectedCity = cities.find((city) => city.id === id);
            return selectedCity ? selectedCity.name : "";
          }}
          hasError={props.touched.city && Boolean(props.errors.city)}
          isOptionEqualToValue={(option, selectedValue) => {
            const selectedId = typeof selectedValue === "string" ? selectedValue : selectedValue && selectedValue.id;
            return option.id === selectedId;
          }}
          label="Población *"
          name="city"
          onChange={(_event, value) => {
            if (value) {
              setFieldValue("city", value.id);
            }
          }}
          options={cities}
          theme={props.theme}
          value={cities.find((city) => city.id === props.value) || null}
        />
      </div>
    );
  }

  return view;
}
